<template>
  <div class="container" @click="onClick">
    <div class="top">
      <span class="phase">{{ phase || '—' }}</span>
      <div class="distance-group">
        <span class="material-symbols-outlined size-24 location-icon">
          location_on
        </span>
        <span class="distance">{{ Math.round(nearestLocation.distance || '') || '—' }} miles</span>
      </div>
    </div>
    <div class="location">
      <span >{{ nearestLocation.city || '' }}</span>
      <span v-show="nearestLocation.city && nearestLocation.country">, </span>
      <span >{{ nearestLocation.country || '' }}</span>
    </div>
    <div class="txt">
      <p>
        {{ descriptionText || DEFAULT_TEXT }}
      </p>
    </div>
    <div class="id">
      <span>{{ id || '—' }}</span>
    </div>
  </div>
</template>

<script setup>
// Copyright (c) 2020-2023 dātma, inc™
//
// Unauthorized copying of this file, via any medium is strictly prohibited
// Proprietary and confidential

import { computed, defineEmits, defineProps } from 'vue'

const emit = defineEmits(['openDetailsModal'])

const props = defineProps({
  nearestLocation: Object,
  description: String,
  phase: String,
  distance: Number,
  id: String,
})

const DEFAULT_TEXT = 'No information found.'
const descriptionText =
  computed(() => props.description !== 'null' ? props.description : DEFAULT_TEXT)

const onClick = () => {
  emit('openDetailsModal', props.id, props.description, 'Trial')
}

</script>

<style lang="scss" scoped>
.container {
  flex-grow: 1;
  flex-shrink: 1;
  transition: all linear 200ms;
  display: flex;
  max-width: 11.5rem;
  height: 7rem;
  padding: 0.9rem;
  flex-direction: column;
  border-radius: 9.72px;
  background: #F7F9FB;
  justify-content: flex-start;
  align-items: flex-start;
  overflow: hidden;
  font-size: 0.63rem;
  color: rgba(0, 0, 0, 0.40);

  cursor: pointer;

  &:hover {
    background: var(--Grey200);
  }

  &:hover>.txt>p {
    color: var(--Grey800);
  }

  &:hover>.location {
    font-weight: 600;
  }
}

.location {
  color: var(--Black);
  margin: 4px 0;
}

.txt {
  height: 1rem;
  margin-bottom: 1rem;
}

.txt p {
  margin-top: 0.2rem;
  overflow: hidden;
  color: var(--Grey600);
  font-size: 0.67rem;
  font-style: normal;
  font-weight: 400;
  text-align: left;

  //line clamping
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
}

.phase {
  margin-right: 20px;
  color: var(--Grey700);
  background-color: #e9ffaa;
  width: max-content;
  border-radius: 4px;
  margin: 2px;
  padding: 4px;
  text-align: center;
  height: 1.25rem;
}

.top {
  display: flex;
}

.distance-group {
  padding: 3px;
  display: flex;
  color: var(--Grey700);
  background-color: var(--Grey300);
  width: max-content;
  border-radius: 4px;
  margin: 2px;
  text-align: center;
  justify-content: flex-start;
  align-items: center;
  height: 1.25rem;
}

.location-icon {
  padding-bottom: 3px;
  font-size: 120%;
}

.id {
  color: var(--Grey700);
  margin-top: 5px;
}
</style>
